import Dropdown from './dropdown';
import DropdownButton from './dropdown-button';
Dropdown.Button = DropdownButton;
export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/dropdown/index.js
// module id = 234
// module chunks = 14